/**
 * Created by wwei on 2017-11-29.
 */

import { message } from "antd";

message.config({
  duration: 5,
  maxCount: 3,
  top: 60
});

export default class NotificationManager {
  static success(msg) {
    message.success(msg);
  }

  static info(msg) {
    message.info(msg);
  }

  static warn(msg) {
    message.warn(msg);
  }

  static error(msg) {
    message.error(msg);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/CustomNotificationManager.js